import { render, staticRenderFns } from "./screenshot.vue?vue&type=template&id=088f2f71"
import script from "./screenshot.vue?vue&type=script&lang=js"
export * from "./screenshot.vue?vue&type=script&lang=js"
import style0 from "./screenshot.vue?vue&type=style&index=0&id=088f2f71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports